export const ASIDE_COLLAPSE = 'ASIDE_COLLAPSE' // aside 折叠